import { type RootState } from "~/app/store";
import { selectProductDescriptor } from "~/domains/product/redux/selectors";
import { createSelector } from "reselect";
import { type LineItem } from "~/features/cart/cart/models/CartData";
import { selectIsCartAboveThreshold } from "~/features/cart/cart/redux/selectors/cartSelectors";
import { selectCart } from "~/features/cart/cart/redux/selectors/groupedCartSelectors";
import uniq from "lodash/uniq";
import { isKITProduct } from "~/domains/product/types/ProductData";

const selectPackEntries = createSelector(
  (state: RootState) => state.cart.packEntriesById,
  (packEntriesById) => Object.values(packEntriesById),
);
const isInvalid = (item: LineItem) => !item.valid;
const isMissingPackSize = (item: LineItem) => item.packSize === undefined;
export const selectDisableCheckout = (externalDisableCheckout: boolean) => (state: RootState) => {
  if (externalDisableCheckout) {
    return true;
  }

  const packEntries = selectPackEntries(state);

  if (!selectIsCartAboveThreshold(state)) {
    if (packEntries.some(isMissingPackSize)) {
      return true;
    }
  }

  if (packEntries.some(isInvalid)) {
    return true;
  }
};
export const selectIsRequestInFlight = (state: RootState) => state.cartPage.requestInFlight;
export const selectAccountNumber = (state: RootState) => state.cartPage.accountNumber;
export const selectIsDstError = (state: RootState) => state.cartPage.dstError;
export const selectIsPnaLoading = (state: RootState) => {
  return Object.values(state.cart.packEntriesById).some((packEntry) => {
    const productDescriptor = selectProductDescriptor(state, {
      productCode: packEntry.productCode,
      priceReference: packEntry.priceReference,
    });
    return productDescriptor.isLoading;
  });
};
export const selectCartContainsHousingKIT = (state: RootState) => {
  const cart = selectCart(state);
  let productCodes = [cart.orderables, cart.quotables, ...cart.bundles]
    .flatMap((group) => group.entries)
    .flatMap((entry) => entry.packGroups)
    .flatMap((entry) => entry.packEntryIds)
    .map((id) => state.cart.packEntriesById[id])
    .map((lineItem) => lineItem.productCode);
  productCodes = uniq(productCodes);
  return productCodes.some((code) => isKITProduct(state.products.basic[code]));
};
